<template>
    <div v-if="historique">
        <div v-for="edition in historique.past_editions" :key="edition.id_module">


            <v-row>
                <v-col cols="12" class="pa-2 my-3">
                    <div class="ml-2 text-h5 font-weight-bold">{{ edition.nom }} | {{ edition.date }}</div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" md="6" class="pa-2">
                    <ListCoursesOverview :id_module="edition.id_module"></ListCoursesOverview>
                </v-col>
                <v-col cols="12" md="6" class="pa-2">
                    <GraphInscriptionsPerWeek :id_module="edition.id_module"></GraphInscriptionsPerWeek>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import AdminService from "@/services/admin.service.js";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import GraphInscriptionsPerWeek from "../Parcours/GraphInscriptionsPerWeek.vue";
import ListCoursesOverview from "../Parcours/ListCoursesOverview.vue";
export default {
    components: { GraphInscriptionsPerWeek, ListCoursesOverview },
    data() {
        return {
            historique: null,
            selected_edition_id: null

        }
    },
    computed: {
        ...mapStores(useMainStore),


    },
    methods: {
        async loadHistorique() {
            this.historique = await AdminService.getHistorique(this.mainStore.module.evenement.id);
            this.selected_edition_id = this.historique.past_editions[0].id_module;
        }
    },
    async mounted() {
        await this.loadHistorique();

    }
};
</script>

<style lang="scss" scoped></style>